import React, { useEffect, useState } from "react";
import styles from "./cartPage.module.css";
import { Box, CircularProgress, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deleteCarts, getAllCarts, updateCarts } from "../../../redux/cartSlice";
import { addWishlist } from "../../../redux/wishlistSlice";
import Emptycart from "../emptycart/Emptycart";
import CouponPopup from "../../components/couponpopup/CouponPopup";
import { useNavigate } from "react-router-dom";
import { resetUnreadCountsThunk } from "../../../redux/userSlice";
import CustomSeparator from "../../components/maincomps/breadcrumbs/Breadcrumbs";
import breadcrumbStyle from '../../components/maincomps/breadcrumbs/breadcrumbs.module.css';
import { useCurrency } from '../../context/CurrencyContext';

const CartPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cartsData, isLoading, isRefresh } = useSelector((state) => state.carts);
  const { formatPrice } = useCurrency();
  // console.log('cartsData=================', cartsData);


  //state

  const [selectedValue, setSelectedValue] = useState("");
  // console.log('selectedValue', selectedValue);

  useEffect(() => {
    const data = {
      type: 'cart'
    }
    dispatch(resetUnreadCountsThunk(data))
    dispatch(getAllCarts())
  }, [dispatch, isRefresh])


  const [advance, setAdvance] = useState('');
  // console.log('advance=====', advance);


  const handleChange = (event, advancePayment, productId) => {
    const paymentType = event.target.value;

    setSelectedValue((prev) => ({
      ...prev,
      [productId]: paymentType,
    }));

    setAdvance((prev) => ({
      ...prev,
      [productId]: paymentType === "Ad Paid" ? advancePayment : 0, // Reset to 0 if not "Ad Paid"
    }));

    console.log("Selected Payment Method:", paymentType, "Advance Payment:", advancePayment, "Product ID:", productId);
  };


  // Calculate total advance payment
  const totalAdvancePaid = Object.values(advance).reduce((sum, amount) => sum + (amount || 0), 0);

  // Compute grand total
  const grandTotal = (cartsData?.sellingPrice || 0) - totalAdvancePaid;
  const price = (cartsData?.totalPrice || 0) - totalAdvancePaid;

  const datas = {
    state: cartsData,
    grandTotal: grandTotal,
    price: price,
    product: cartsData?.data?.map((item) => ({
      ...item,
      selectedPaymentType: selectedValue[item._id] || "Fully Paid", // Default to Fully Paid
      adPaymentAmount:
        selectedValue[item._id] === "Ad Paid"
          ? item.sellingPrice / 2 // Half if Advance Payment is selected
          : 0, // Full if Fully Paid is selected
    })),
  }


  const handleRemoveItem = (item) => {
    dispatch(deleteCarts(item));
  };

  const addInWishlist = async (item) => {
    const updatedQuantity = item.quantity + 1;
    let data = {
      productId: item.productId,
      quantity: updatedQuantity
    }
    dispatch(addWishlist(data))

  }



  return (
    <>
      <div className={breadcrumbStyle.breadcrumbStyle}>
        <CustomSeparator home="Home" type="Cart" />
      </div>
      {isLoading ? (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: 20, width: '100%' }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {cartsData?.data?.length > 0 ? (
            <div className={styles.mbview}>
              <div className={styles.Container}>
                <h2>Cart</h2>
                <div className={styles.cartContainer}>
                  {/* Left Side - Cart Items */}
                  <div className={styles.cartItems}>
                    <table className={styles.cartTable}>
                      <thead>
                        <tr>
                          <th className={styles.heading}>Product</th>
                          <th className={styles.heading}>Price</th>
                          <th className={styles.heading}>Options</th>
                          {/* <th className={styles.heading}>Subtotal</th> */}
                          <th className={styles.heading}></th>
                        </tr>
                      </thead>

                      <tbody>
                        {cartsData?.data?.map((item) => {
                          const advancePayment = item?.sellingPrice / 2
                          return (
                            <tr key={item._id} className={styles.productDetailes}>
                              <td>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }} onClick={() => navigate(`/prodDescription/${item?.productId}`)}>
                                  <img
                                    src={item.featurerdImage}
                                    alt={item.altText}
                                    className={styles.productImage}

                                  />
                                  <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', flexDirection: 'column' }}>
                                    <p className={styles.productNameText}>{item.productName}</p>
                                    <div style={{
                                      backgroundColor: '#F6F6F6',
                                      color: '#000',
                                      borderRadius: '0px',
                                      fontSize: '10px',
                                      padding: '4px'
                                    }}>{item?.product?.gold?.orderType}</div></div>
                                </div>
                              </td>

                              {/* <td className={styles.head}>₹{item.sellingPrice?.toLocaleString("en-IN")}
                                {item?.discount === 0 ? (
                                  null
                                ) : (
                                  <span className={styles.totalPriceText}>₹{item?.totalPrice?.toLocaleString("en-IN")}</span>
                                )}
                              </td> */}
                              <td className={styles.head}>{formatPrice(item.sellingPrice)}
                                {item?.discount === 0 ? (
                                  null
                                ) : (
                                  <span className={styles.totalPriceText}>{formatPrice(item?.totalPrice)}</span>
                                )}
                              </td>
                              {item?.product?.gold?.orderType === 'Made to orders' ? (
                                <td className={styles.head}>
                                  <RadioGroup value={selectedValue[item._id] || ""}
                                    onChange={(e) =>
                                      handleChange(e, item.sellingPrice / 2, item._id)}>
                                    <FormControlLabel
                                      value="Fully Paid"
                                      control={<Radio sx={{ padding: '4px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                                      label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '10px' }}>
                                          Full Payment
                                        </Box>
                                      }
                                    />
                                    <FormControlLabel
                                      value="Ad Paid"
                                      control={<Radio sx={{ padding: '4px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                                      label={
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '10px' }}>
                                          Advance payment (50%){' '}
                                          <Typography sx={{
                                            backgroundColor: '#fff',
                                            color: '#000',
                                            borderRadius: '0px',
                                            fontSize: '10px',
                                            border: '1px solid #00000033',
                                            background: '#fff',
                                            textAlign: 'center',
                                            padding: '4px 6px 2px 6px',
                                          }}>
                                            {/* ₹{(advance[item._id] || 0)?.toLocaleString("en-IN")} */}
                                            {formatPrice(advance[item._id] || 0)}
                                          </Typography>
                                        </Box>
                                      }
                                    />
                                  </RadioGroup>
                                  {selectedValue[item?._id] === 'Ad Paid' && (
                                    <Typography sx={{
                                      color: '#f71313',
                                      fontSize: '12px',
                                      fontFamily: 'karla',
                                      fontWeight: 400,

                                    }}>
                                      Minimum 25 Days required and 5 Days of Shipping. Price may increase or decrease according to the Weight, when a new product is made.
                                    </Typography>
                                  )}
                                </td>
                              ) : (
                                <td style={{ display: 'flex', justifyContent: 'flex-start', alignItems: "center", height: "90px" }}>
                                  -
                                </td>
                              )}
                              {/* <td className={styles.head}>
                              ₹{item?.subtotal?.toLocaleString("en-IN")}
                            </td> */}

                              <td>
                                <div style={{ display: 'flex', gap: '10px', }}>
                                  <button
                                    className={styles.removeButton}
                                    onClick={() => handleRemoveItem(item?.productId)}
                                  >
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M12 23.5C18.0748 23.5 23 18.5748 23 12.5C23 6.42525 18.0748 1.5 12 1.5C5.92525 1.5 1 6.42525 1 12.5C1 18.5748 5.92525 23.5 12 23.5Z" stroke="#CCCCCC" stroke-miterlimit="10" />
                                      <path d="M16 8.5L8 16.5" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M16 16.5L8 8.5" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>

                                  </button>
                                  <button
                                    className={styles.removeButton}
                                    onClick={() => addInWishlist(item)}
                                  >
                                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g clip-path="url(#clip0_1083_14225)">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5747 7.39823C15.3968 7.39823 16.2003 7.64282 16.8838 8.10108C17.5673 8.55934 18.1 9.21068 18.4146 9.97274C18.7292 10.7348 18.8115 11.5733 18.6511 12.3823C18.4908 13.1913 18.0949 13.9344 17.5137 14.5177C16.9324 15.1009 16.1918 15.4981 15.3856 15.6591C14.5793 15.82 13.7437 15.7374 12.9842 15.4217C12.2248 15.1061 11.5756 14.5715 11.1189 13.8857C10.6622 13.1999 10.4185 12.3936 10.4185 11.5687C10.4185 10.4626 10.8564 9.40185 11.6358 8.61974C12.4153 7.83762 13.4724 7.39823 14.5747 7.39823ZM10.1201 3.5365L9.42117 4.27192L8.72228 3.58459C7.57653 2.45198 6.71064 1.59865 4.93094 1.57538L4.70983 1.58624C3.75346 1.60487 2.83574 1.96837 2.12454 2.61024C1.77512 2.94 1.49717 3.33846 1.30802 3.78078C1.11888 4.22311 1.02259 4.69979 1.02518 5.18111V5.39367C1.13187 8.38344 3.9831 10.9915 6.34728 13.1513C6.81115 13.5686 7.241 13.9689 7.66003 14.3739L9.40262 16.0573L10.3164 15.1465C10.4216 15.2706 10.5314 15.3917 10.6458 15.5065C10.7726 15.6352 10.9071 15.7563 11.0463 15.8726L9.4088 17.5017L6.95804 15.1186C6.57303 14.7478 6.12772 14.3428 5.66385 13.9162C3.14969 11.6215 0.125276 8.85511 3.19628e-05 5.42935V5.16869C-0.00229962 4.54775 0.122954 3.933 0.367973 3.3628C0.612992 2.7926 0.972517 2.2792 1.4241 1.85465C2.315 1.04205 3.46759 0.578335 4.67117 0.548269H4.94795C7.11266 0.576197 8.10998 1.53193 9.40107 2.80573C10.4618 1.67002 11.3478 0.740658 13.1429 0.532754C14.1532 0.421436 15.174 0.607416 16.0808 1.06803C16.8438 1.4502 17.5064 2.00722 18.0151 2.69402C18.5305 3.38215 18.8559 4.19456 18.9583 5.04923C19.0567 5.94298 18.9035 6.84654 18.5161 7.65733L18.4898 7.62941C18.2458 7.38444 17.9797 7.16267 17.695 6.96691C17.9211 6.39586 18.0045 5.77795 17.9378 5.16714C17.8559 4.49154 17.5984 3.84944 17.1909 3.30532C16.7782 2.74887 16.2412 2.29721 15.6231 1.98653C14.8949 1.61797 14.0758 1.46922 13.2651 1.55831C11.824 1.72432 11.0555 2.54352 10.1201 3.5365ZM13.9609 9.80929C13.961 9.72875 13.9773 9.64906 14.0088 9.57501V9.5657C14.0391 9.49447 14.0827 9.4297 14.1372 9.37487C14.2516 9.26096 14.4058 9.19638 14.567 9.19489C14.647 9.19594 14.7262 9.21172 14.8005 9.24143C14.8747 9.27298 14.9424 9.31824 15 9.37487C15.0565 9.43158 15.1012 9.49911 15.1314 9.57346V9.58432C15.1632 9.65535 15.1821 9.73155 15.187 9.80929V11.0505H16.4132C16.4933 11.0507 16.5726 11.0665 16.6467 11.0971C16.7213 11.1278 16.7891 11.1732 16.8461 11.2305C16.9023 11.2875 16.947 11.355 16.9776 11.4291V11.4384C17.0045 11.5066 17.0192 11.5791 17.0209 11.6525V11.6711C17.02 11.7479 17.0042 11.8238 16.9745 11.8945C16.9436 11.9693 16.8984 12.0373 16.8415 12.0947C16.7854 12.1513 16.7187 12.1961 16.6451 12.2266H16.6343C16.5637 12.2538 16.4889 12.2685 16.4132 12.27H15.1762V13.5004C15.176 13.5807 15.1603 13.6603 15.1298 13.7346C15.0986 13.8092 15.0534 13.8771 14.9969 13.9348L14.9845 13.9456C14.9307 13.9972 14.8677 14.0382 14.7989 14.0667H14.7881C14.7175 14.094 14.6427 14.1087 14.567 14.1101C14.4869 14.1099 14.4076 14.0941 14.3335 14.0636C14.2589 14.0328 14.1911 13.9874 14.1341 13.9301C14.0772 13.8743 14.0324 13.8072 14.0026 13.7331C13.9721 13.6593 13.9558 13.5803 13.9547 13.5004V12.2762H12.7363C12.656 12.2761 12.5766 12.2598 12.5028 12.2281H12.4935C12.4225 12.1977 12.358 12.154 12.3033 12.0993C12.2467 12.0426 12.202 11.9751 12.1719 11.9007V11.8899C12.1436 11.8203 12.1273 11.7463 12.124 11.6711C12.1233 11.5907 12.1391 11.5109 12.1704 11.4368C12.2152 11.3238 12.2924 11.2267 12.3924 11.1579C12.4923 11.0891 12.6104 11.0517 12.7316 11.0505H13.9686V9.80929H13.9609Z" fill="#666666" />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_1083_14225">
                                          <rect width="19" height="17" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </button>

                                </div>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>

                    </table>

                    <div className={styles.addMoreItems}>
                      <button className={styles.more} onClick={() => navigate('/')}>
                        Continue Shopping
                      </button>
                    </div>
                  </div>


                  <div className={styles.orderSummarymain}>
                    {/* <div className={styles.orderSummary}>
                      <div className={styles.Order}>Coupons</div>

                      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>


                        <div className={styles.applyCouponStyle}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5459 3.57029C11.9641 3.15205 12.5498 2.9466 13.1377 3.01192L21 3L20.9881 10.8623C21.0534 11.4502 20.848 12.0359 20.4297 12.4541L11.4541 21.4297C10.6937 22.1901 9.46093 22.1901 8.70056 21.4297L2.57027 15.2994C1.80991 14.5391 1.80991 13.3063 2.57027 12.5459L11.5459 3.57029ZM13 5L3.94704 13.9227L10.0773 20.053L19 11V5H13ZM14 8L16 10L14 12L12 10L14 8Z" fill="#7E84A3" />
                          </svg>
                          <span>Apply coupons</span>

                        </div>
                        <button
                          className={styles.applyButton}
                          onClick={() => openCouponPopup()}
                        >APPLY
                        </button>
                      </div>
                    </div> */}

                    <div className={styles.orderSummary}>
                      <div className={styles.Order}>Order Summary</div>

                      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        <div className={styles.summaryItem}>
                          <span className={styles.priceSummary}>Price</span>
                          {/* <span className={styles.priceSummary}>₹ {price?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                          <span className={styles.priceSummary}>{formatPrice(price)}</span>
                        </div>
                        {cartsData?.mrpdiscount === 0 ? (
                          null
                        ) : (
                          <div className={styles.summaryItem}>
                            <span className={styles.priceSummary}>Mrp Discount</span>
                            {/* <span className={styles.priceSummary}>₹ {cartsData?.mrpdiscount?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                            <span className={styles.priceSummary}>{formatPrice(cartsData?.mrpdiscount)}</span>
                          </div>
                        )}
                        {/* <div className={styles.summaryItem}>
                          <span className={styles.priceSummary}>Coupon discount</span>
                          <span className={styles.coupon} onClick={() => openCouponPopup()}>Apply coupon</span>
                        </div> */}
                        <div className={styles.summaryItem} style={{ borderBottom: '1px solid #D1D1D8', paddingBottom: '20px' }}>
                          <span className={styles.priceSummary}>Shipping</span>
                          <span className={styles.FreeSummary}>Free</span>
                        </div>
                        <div className={styles.summaryTotal}>
                          <span>TOTAL</span>
                          {/* <span>₹ {grandTotal?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span> */}
                          <span>{formatPrice(grandTotal)}</span>
                        </div>
                        {/* <div className={styles.summaryItem}>
                          <span className={styles.priceSummary}>Estimated Delivery by</span>
                          <span className={styles.bold}> 01 Jun, 2024</span>
                        </div> */}
                      </div>
                      <button className={styles.checkoutButton} onClick={() => navigate(`/checkout`, { state: datas })}>Proceed to Checkout</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.mobilecontainer}>
                <div className={styles.mobilecontant1}>
                  {cartsData?.data?.map((item) => (
                    <div className={styles.mobilecontant} key={item?._id}>
                      <div className={styles.mobilebox1} onClick={() => navigate(`/prodDescription/${item?.productId}`)}>
                        <img
                          src={item.featurerdImage}
                          alt="Product Name"
                          className={styles.productImage}
                        />
                        <div style={{ display: 'flex', gap: '10px', }}>
                          <button
                            className={styles.removeButton}
                          >
                            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_1083_14225)">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5747 7.39823C15.3968 7.39823 16.2003 7.64282 16.8838 8.10108C17.5673 8.55934 18.1 9.21068 18.4146 9.97274C18.7292 10.7348 18.8115 11.5733 18.6511 12.3823C18.4908 13.1913 18.0949 13.9344 17.5137 14.5177C16.9324 15.1009 16.1918 15.4981 15.3856 15.6591C14.5793 15.82 13.7437 15.7374 12.9842 15.4217C12.2248 15.1061 11.5756 14.5715 11.1189 13.8857C10.6622 13.1999 10.4185 12.3936 10.4185 11.5687C10.4185 10.4626 10.8564 9.40185 11.6358 8.61974C12.4153 7.83762 13.4724 7.39823 14.5747 7.39823ZM10.1201 3.5365L9.42117 4.27192L8.72228 3.58459C7.57653 2.45198 6.71064 1.59865 4.93094 1.57538L4.70983 1.58624C3.75346 1.60487 2.83574 1.96837 2.12454 2.61024C1.77512 2.94 1.49717 3.33846 1.30802 3.78078C1.11888 4.22311 1.02259 4.69979 1.02518 5.18111V5.39367C1.13187 8.38344 3.9831 10.9915 6.34728 13.1513C6.81115 13.5686 7.241 13.9689 7.66003 14.3739L9.40262 16.0573L10.3164 15.1465C10.4216 15.2706 10.5314 15.3917 10.6458 15.5065C10.7726 15.6352 10.9071 15.7563 11.0463 15.8726L9.4088 17.5017L6.95804 15.1186C6.57303 14.7478 6.12772 14.3428 5.66385 13.9162C3.14969 11.6215 0.125276 8.85511 3.19628e-05 5.42935V5.16869C-0.00229962 4.54775 0.122954 3.933 0.367973 3.3628C0.612992 2.7926 0.972517 2.2792 1.4241 1.85465C2.315 1.04205 3.46759 0.578335 4.67117 0.548269H4.94795C7.11266 0.576197 8.10998 1.53193 9.40107 2.80573C10.4618 1.67002 11.3478 0.740658 13.1429 0.532754C14.1532 0.421436 15.174 0.607416 16.0808 1.06803C16.8438 1.4502 17.5064 2.00722 18.0151 2.69402C18.5305 3.38215 18.8559 4.19456 18.9583 5.04923C19.0567 5.94298 18.9035 6.84654 18.5161 7.65733L18.4898 7.62941C18.2458 7.38444 17.9797 7.16267 17.695 6.96691C17.9211 6.39586 18.0045 5.77795 17.9378 5.16714C17.8559 4.49154 17.5984 3.84944 17.1909 3.30532C16.7782 2.74887 16.2412 2.29721 15.6231 1.98653C14.8949 1.61797 14.0758 1.46922 13.2651 1.55831C11.824 1.72432 11.0555 2.54352 10.1201 3.5365ZM13.9609 9.80929C13.961 9.72875 13.9773 9.64906 14.0088 9.57501V9.5657C14.0391 9.49447 14.0827 9.4297 14.1372 9.37487C14.2516 9.26096 14.4058 9.19638 14.567 9.19489C14.647 9.19594 14.7262 9.21172 14.8005 9.24143C14.8747 9.27298 14.9424 9.31824 15 9.37487C15.0565 9.43158 15.1012 9.49911 15.1314 9.57346V9.58432C15.1632 9.65535 15.1821 9.73155 15.187 9.80929V11.0505H16.4132C16.4933 11.0507 16.5726 11.0665 16.6467 11.0971C16.7213 11.1278 16.7891 11.1732 16.8461 11.2305C16.9023 11.2875 16.947 11.355 16.9776 11.4291V11.4384C17.0045 11.5066 17.0192 11.5791 17.0209 11.6525V11.6711C17.02 11.7479 17.0042 11.8238 16.9745 11.8945C16.9436 11.9693 16.8984 12.0373 16.8415 12.0947C16.7854 12.1513 16.7187 12.1961 16.6451 12.2266H16.6343C16.5637 12.2538 16.4889 12.2685 16.4132 12.27H15.1762V13.5004C15.176 13.5807 15.1603 13.6603 15.1298 13.7346C15.0986 13.8092 15.0534 13.8771 14.9969 13.9348L14.9845 13.9456C14.9307 13.9972 14.8677 14.0382 14.7989 14.0667H14.7881C14.7175 14.094 14.6427 14.1087 14.567 14.1101C14.4869 14.1099 14.4076 14.0941 14.3335 14.0636C14.2589 14.0328 14.1911 13.9874 14.1341 13.9301C14.0772 13.8743 14.0324 13.8072 14.0026 13.7331C13.9721 13.6593 13.9558 13.5803 13.9547 13.5004V12.2762H12.7363C12.656 12.2761 12.5766 12.2598 12.5028 12.2281H12.4935C12.4225 12.1977 12.358 12.154 12.3033 12.0993C12.2467 12.0426 12.202 11.9751 12.1719 11.9007V11.8899C12.1436 11.8203 12.1273 11.7463 12.124 11.6711C12.1233 11.5907 12.1391 11.5109 12.1704 11.4368C12.2152 11.3238 12.2924 11.2267 12.3924 11.1579C12.4923 11.0891 12.6104 11.0517 12.7316 11.0505H13.9686V9.80929H13.9609Z" fill="#666666" />
                              </g>
                              <defs>
                                <clipPath id="clip0_1083_14225">
                                  <rect width="19" height="17" fill="white" transform="translate(0 0.5)" />
                                </clipPath>
                              </defs>
                            </svg>
                          </button>
                          <button
                            className={styles.removeButton}
                          >
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 23.5C18.0748 23.5 23 18.5748 23 12.5C23 6.42525 18.0748 1.5 12 1.5C5.92525 1.5 1 6.42525 1 12.5C1 18.5748 5.92525 23.5 12 23.5Z" stroke="#CCCCCC" stroke-miterlimit="10" />
                              <path d="M16 8.5L8 16.5" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M16 16.5L8 8.5" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                          </button>
                        </div>
                      </div>
                      <div className={styles.head}>
                        <p className={styles.productNameText}>{item.productName}</p>
                        <div style={{
                          backgroundColor: '#F6F6F6',
                          color: '#000',
                          borderRadius: '0px',
                          fontSize: '10px',
                          padding: '4px',
                          width: 'fit-content'
                        }}>{item?.product?.gold?.orderType}</div>
                      </div>
                      <div className={styles.mobilebox}>
                        <p className={styles.heading}>Price</p>
                        {/* <p className={styles.head}>₹{item?.sellingPrice?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p> */}
                        <p className={styles.head}>{formatPrice(item?.sellingPrice)}</p>
                      </div>
                      <p className={styles.heading}>Options</p>
                      {item?.product?.gold?.orderType === 'Made to orders' ? (
                        <td className={styles.head}>
                          <RadioGroup value={selectedValue[item._id] || ""}
                            onChange={(e) =>
                              handleChange(e, item.sellingPrice / 2, item._id)}>
                            <FormControlLabel
                              value="Fully Paid"
                              control={<Radio sx={{ padding: '4px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                              label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '10px' }}>
                                  Full Payment
                                </Box>
                              }
                            />
                            <FormControlLabel
                              value="Ad Paid"
                              control={<Radio sx={{ padding: '4px', "&.Mui-checked": { color: "#ff5722", }, }} />}
                              label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '10px' }}>
                                  Advance payment (50%){' '}
                                  <Typography sx={{
                                    backgroundColor: '#fff',
                                    color: '#000',
                                    borderRadius: '0px',
                                    fontSize: '10px',
                                    border: '1px solid #00000033',
                                    background: '#fff',
                                    textAlign: 'center',
                                    padding: '4px 6px 2px 6px',
                                  }}>
                                    {/* ₹{(advance[item._id] || 0)?.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} */}
                                    {formatPrice(advance[item._id] || 0)}
                                  </Typography>
                                </Box>
                              }
                            />
                          </RadioGroup>
                          {selectedValue[item?._id] === 'Ad Paid' && (
                            <Typography sx={{
                              color: '#f71313',
                              fontSize: '12px',
                              fontFamily: 'karla',
                              fontWeight: 400,

                            }}>
                              Minimum 25 Days required and 5 Days of Shipping. Price may increase or decrease according to the Weight, when a new product is made.
                            </Typography>
                          )}
                        </td>
                      ) : (
                        <td style={{ display: 'flex', }}>
                          -
                        </td>
                      )}
                      {/* <button className={styles.cartbutton}>Add to Cart</button> */}
                    </div>
                  ))}
                  <div className={styles.addMoreItems}>
                    <button className={styles.more} onClick={() => navigate('/')}>
                      Continue Shopping
                    </button>
                  </div>
                </div>

              </div>
              {/* {cuponPopup &&
                <CouponPopup
                  onClose={closeCuponPopup}
                  data={data}
                  checkoutPrice={cartsData?.sellingPrice}
                />
              } */}
            </div>
          ) : (
            <Emptycart />
          )}
        </>
      )}

    </>
  );
};

export default CartPage;
